import React from 'react';
import { PRICE, PRICE_PLN, SAVINGS, TOTAL_VALUE, valueStack } from '../data/valueStack';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
export function FinalCall() {
  return <section aria-labelledby="final-heading" className="border-y border-night-600 bg-night-950 py-14 sm:py-24" data-id="element-104" data-mp="2ymrm9thxoaqv">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-105" data-mp="2tphpttw4mytj">
        <div data-id="element-106" data-mp="3rbopqqhhk2zk">
          <Eyebrow data-id="element-107" data-mp="3rbf93tibz86j">Podsumowanie</Eyebrow>
          <h2 id="final-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-108" data-mp="3mddj0omhm8lk">
            Kompletny pakiet, <span className="text-amber" data-id="element-109" data-mp="3hcpr80qfpnqa">cena premierowa</span>
          </h2>
          <p className="mt-6 max-w-sm text-sm text-cream-muted" data-id="element-110" data-mp="3dcyw5ktvklfy">
            Jedna płatność, wszystkie materiały od razu na Twoim e-mailu i 10 dni na sprawdzenie ich
            na prawdziwych zajęciach.
          </p>
        </div>
        <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-10" data-id="element-111" data-mp="21vpaqsr6rjc0">
          <p className="text-xs font-semibold uppercase tracking-label text-amber sm:text-sm" data-id="element-112" data-mp="i5jq3jep0d46">
            6 tomów + 6 bonusów
          </p>
          <dl className="mt-5 border-y border-night-600 py-4" data-id="element-113" data-mp="n18wa5l7ws9g">
            {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 py-1.5" data-id="element-114" data-mp="966f2max7ghc">
                <dt className="text-xs text-cream-muted" data-id="element-115" data-mp="d79yfis6funb">{line.label}</dt>
                <dd className="text-xs font-semibold tabular-nums text-cream-soft" data-id="element-116" data-mp="3vi3o8q0h8s8r">{line.value}</dd>
              </div>)}
            <div className="flex items-baseline justify-between gap-4 pt-2" data-id="element-117" data-mp="3ll8u0jb8le0a">
              <dt className="text-[10px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-118" data-mp="3lj5th5cgk2hb">
                Łączna realna wartość
              </dt>
              <dd className="text-xs font-semibold tabular-nums text-cream-muted line-through" data-id="element-119" data-mp="3cllnxk7kbk0w">{TOTAL_VALUE}</dd>
            </div>
          </dl>
          <p className="mt-5 flex items-baseline gap-3" data-id="element-120" data-mp="3hlq4fa8h0er4">
            <span className="font-display text-6xl leading-none text-amber sm:text-7xl" data-id="element-121" data-mp="1n4gniu3r0dh7">{PRICE}</span>
            <span className="font-display text-xl leading-none text-cream-muted line-through" data-id="element-122" data-mp="1ibnie54db34l">{TOTAL_VALUE}</span>
          </p>
          <p className="mt-2 text-sm text-cream-soft" data-id="element-123" data-mp="1ddvhillqw6o9">{PRICE_PLN}</p>
          <p className="mt-3 text-sm font-semibold text-amber-light" data-id="element-124" data-mp="19d1tls8ayrvd">Oszczędzasz dziś {SAVINGS}</p>
          <div className="mt-7" data-id="element-125" data-mp="26185n07k0mjo">
            <CtaButton size="lg" fullWidth data-id="element-126" data-mp="2606smq6z9pzb">
              Tak, chcę to teraz
            </CtaButton>
          </div>
          <ul className="mt-6 space-y-1.5 text-xs text-cream-muted" data-id="element-127" data-mp="211daulknrctc">
            <li data-id="element-128" data-mp="1wzrtoo13ccdc">Płatność jednorazowa &middot; Bez subskrypcji</li>
            <li data-id="element-129" data-mp="1s3b55spzbvzq">Natychmiastowy dostęp do wszystkich materiałów</li>
            <li data-id="element-130" data-mp="lmfz73r8163u">10-dniowa gwarancja satysfakcji</li>
          </ul>
        </div>
      </div>
    </section>;
}